import { Link } from 'react-router-dom';

const Banner = () => (
  <section className="section section_footer-banner">
    <div className="wrapper">
      <div className="section__content-wrap">
        <h2 className="title title_size_m title_white section__title _mb-21 _mb-note-11">
          Let Siteplus empower your business
        </h2>
        {/* <p className="text text_size_l text_white _mb-34 section__text">
          <span className="text__break">
            Contact us to schedule a live demo.
          </span>{' '}
          Let Siteplus empower your business.
        </p>
        <div className="section__btn-wrap">
          <Link
            to="/contact"
            className="btn btn_brand section__btn _w-210 _mb-note-30"
          >
            Request a Demo
          </Link>
           <Link
                        to="/contact"
                        className="btn btn_border section__btn btn_border_white _w-210"
                    >
                        Contact Us
                    </Link> 
        </div> */}
      </div>
    </div>
  </section>
);

export default Banner;
